<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <p class="title is-4 is-spaced">Manage {{ typeStringPlural }}</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="field">
            <p class="control">
              <modal-add-suite
                :contact-type="typeString"
                :meeting-id="meetingId"
                ref="add"
                @editSuite="openEditSuite"
              >
              </modal-add-suite>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <table class="table is-fullwidth table-with-data-labels">
        <thead>
          <tr>
            <th scope="col">{{ typeString }} Name</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="suite in sortedSuites" :key="suite.id">
            <td data-label="Name">
              <span :class="{ missingContacts: !hasContacts(suite) }">
                {{ getCompanySuiteName(suite.name, suite.company.name) }}</span
              >
            </td>
            <td data-label="" class="has-text-right">
              <a
                class="button text-sm lg:text-xs is-outlined"
                title="View Schedule"
                @click="
                  $router.push({
                    name: 'AdminViewSchedule',
                    params: { id: meetingId, suiteId: suite.id }
                  })
                "
              >
                <i class="fas fa-eye"></i>
              </a>
              <modal-edit-suite
                :suite-id="suite.id"
                :contact-type="typeString"
                :meeting-id="meetingId"
                :ref="suite.id"
                @addSuite="openAddSuite"
                class="ml-2"
              >
              </modal-edit-suite>
              <a
                class="button text-sm lg:text-xs is-danger is-outlined ml-2"
                title="Delete"
                @click="deleteSuite(suite)"
              >
                <i class="far fa-trash-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ModalEditSuite from '../shared/ModalEditSuite';
import ModalAddSuite from '../shared/ModalAddSuite';
import swal from 'sweetalert';
import { db } from '@/services/firebase';
import MaxxAPI from '@/services/maxxapi';
import { getCompanySuiteName } from '@/services/utils';

export default {
  props: {
    typeString: {
      type: String
    },
    suites: {
      type: Array
    },
    meetingId: {
      type: String
    }
  },
  data() {
    return {
      meeting: null
    };
  },
  firestore() {
    const users = db
      .collection('meetings')
      .doc(this.meetingId)
      .collection('users');
    const meeting = db.collection('meetings').doc(this.meetingId);

    return {
      users,
      meeting
    };
  },
  computed: {
    sortedSuites() {
      const newArray = [...this.suites];
      return newArray.sort((a, b) => {
        if (
          !a.company ||
          !b.company ||
          (!a.name && !a.company.name) ||
          (!b.name && !b.company.name)
        ) {
          return 0;
        }
        if (a.company.name.toLowerCase() < b.company.name.toLowerCase()) {
          return -1;
        }
        if (a.company.name.toLowerCase() > b.company.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      });
    },
    typeStringPlural() {
      return this.typeString + 's';
    }
  },
  methods: {
    getCompanySuiteName,
    hasContacts(suite) {
      return suite.contacts && suite.contacts.length;
    },
    deleteSuite(suite) {
      swal({
        title: 'Are you sure?',
        text: `By proceeding, ${suite.name} and all of its time slots will be removed.`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancel',
            value: null,
            visible: true,
            className: 'button is-light',
            closeModal: true
          },
          confirm: {
            text: `Yes, remove ${suite.type}`,
            value: true,
            visible: true,
            className: 'button is-danger is-inverted',
            closeModal: true
          }
        },
        dangerMode: true
      }).then(proceed => {
        if (proceed) {
          MaxxAPI.createActivity(
            this.meeting.maxxId,
            suite.company.maxxId,
            suite.name,
            'deleted'
          )
            .then(() => {
              this.updateUsers(suite);
              db.collection('meetings')
                .doc(this.meetingId)
                .collection('suites')
                .doc(suite.id)
                .delete();
            })
            .catch(e => {
              swal({
                title: 'No MatrixMaxx session',
                text:
                  'Your MatrixMaxx session is no longer active. A session is required to write activity data to MatrixMaxx. Please login and retry this action.',
                icon: 'error'
              });
            });
        }
      });
    },
    updateUsers(suite) {
      if (suite.contacts) {
        suite.contacts.forEach(contact => {
          this.$firestoreRefs.users
            .doc(contact.username)
            .get()
            .then(userDoc => {
              let suites = userDoc.data().suites;
              delete suites[suite.id];
              this.$firestoreRefs.users.doc(contact.username).update({
                suites: suites
              });
            });
        });
      }
    },
    openEditSuite(id) {
      this.$refs[id][0].showingModal = true;
    },
    openAddSuite() {
      this.$refs['add'].showingModal = true;
    }
  },
  components: {
    ModalEditSuite,
    ModalAddSuite
  }
};
</script>
<style scoped>
.missingContacts {
  color: red;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ManageSuites.vue